import { render, staticRenderFns } from "./gastos.vue?vue&type=template&id=7df3ac36&"
import script from "./gastos.vue?vue&type=script&lang=js&"
export * from "./gastos.vue?vue&type=script&lang=js&"
import style0 from "./gastos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports